import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { InvitationType } from "../api";
import { INVITATION_TYPE_MESSAGES } from "conference/messages";

type Props = {
    value: InvitationType;
    onChange: (event: SelectChangeEvent<InvitationType>) => void;
    disabled?: boolean;
};

const InvitationTypeSelect = ({ value, onChange, disabled }: Props) => {
    return (
        <Select
            value={value}
            onChange={onChange}
            disabled={disabled}
            fullWidth
            size="small"
            style={{ textAlign: "left" }}
        >
            {Object.values(InvitationType).map((item) => {
                return (
                    <MenuItem key={item} value={item}>
                        <FormattedMessage {...INVITATION_TYPE_MESSAGES[item]} />
                    </MenuItem>
                );
            })}
        </Select>
    );
};

export default InvitationTypeSelect;
